module.exports = __webpack_public_path__ + "static/sav_pbc-dd18fedc535995b2b3daefeb0259b18c.png";